import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { DA, EN } from '../assets/lang'

Vue.use(VueI18n)

export default new VueI18n({
	locale: window.localStorage.language || navigator.language || 'da',
	messages: {
		da: DA,
		en: EN,
		'en-US': EN,
		'da-DK': DA
	}
})



// WEBPACK FOOTER //
// ./src/plugins/vue-i18n.js